import { CommonModule } from '@angular/common';
import { Component, Input, computed, signal } from '@angular/core';
import { ImportJob } from '../../../project-corpus/domain/types';
import { SearchRecordRow, toSearchRecordRow } from './search-record.model';

/**
 * Read-only search reproducibility record: one row per import job (source, query terms, filters,
 * search date, records imported, duplicates removed). Presentational and reused on the corpus and
 * completed pages. Fed the corpus ImportJob domain model directly.
 */
@Component({
  selector: 'app-search-record',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './search-record.component.html',
})
export class SearchRecordComponent {
  private readonly _jobs = signal<readonly ImportJob[]>([]);

  @Input() set jobs(value: readonly ImportJob[] | null | undefined) {
    this._jobs.set(value ?? []);
  }

  readonly rows = computed<SearchRecordRow[]>(() => this._jobs().map(toSearchRecordRow));
}
